<!--counter section start-->
<section class="agency counter counter-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-3 col-6 counter-container" *ngFor="let data of counter">
                <div class="counters" aTilt data-tilt data-tilt-max="45" data-tilt-speed="900"
                    data-tilt-perspective="700">
                    <img [src]="data.img" [alt]="data.text" class="img-fluid counter-img icons-sound" loading="lazy">
                    <div class="counter-text">
                        <div class="count-number">
                            <h2 class="counts text-center text-white"><span class="counter" [CountTo]="data.count"
                                    [from]="0" [duration]="7"></span></h2>
                        </div>
                        <div class="count-desc">
                            <h5 class="text-center text-white">{{data.text}}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--counter section end-->